import { useCallback, useState } from 'react';
import { getBankAccountAuth, needsOtpFromHandle } from '../helpers/bankAccountAuth';

export default function useBankAccountOtpModal() {
    const [openModalOtp, setOpenModalOtp] = useState(false);
    const [otpUuid, setOtpUuid] = useState('');
    const [otpInitialMessage, setOtpInitialMessage] = useState('');
    const [otpInitialMode, setOtpInitialMode] = useState(null);
    const [otpInitialQrCode, setOtpInitialQrCode] = useState('');

    const openOtpFromHandle = useCallback((uuid, data = {}) => {
        if (!uuid || !needsOtpFromHandle(data)) {
            return;
        }
        const auth = getBankAccountAuth(data);
        setOtpUuid(uuid);
        setOtpInitialMessage(auth.authMessage || auth.message || '');
        setOtpInitialMode(auth.otpMode || null);
        setOtpInitialQrCode(auth.qrCode || '');
        setOpenModalOtp(true);
    }, []);

    const closeOtpModal = useCallback(() => {
        setOpenModalOtp(false);
    }, []);

    const markOtpResolved = useCallback(() => {
        setOpenModalOtp(false);
    }, []);

    return {
        openModalOtp,
        otpUuid,
        otpInitialMessage,
        otpInitialMode,
        otpInitialQrCode,
        closeOtpModal,
        markOtpResolved,
        openOtpFromHandle,
    };
}
